export const dateRangeTypes = [
    'day', 'month', 'year', 'custom'
];